import { Autocomplete } from '@material-ui/lab';
import { TextField, Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { useFormStyles } from '../../styles/useFormStyles';
import { ILocation } from 'types/Location';
import { useDebounceEffect } from 'pages/Locations/useDebounceEffect';
import { useState } from 'react';

export interface LocationSelectOption {
  address: string;
  name: string;
  id: string;
}

export const locationSelectOption = (location: ILocation): LocationSelectOption => ({
  address: `${location.address}, ${location.city}`,
  name: location.name || '',
  id: location.id || '',
});

const DELAY = 400; // ms

export const LocationNameAutocomplete = observer(
  ({ divKey, options, updateInputValue, inputChangeCallback }: any) => {
    const formClasses = useFormStyles();

    const [someVal, setSomeVal] = useState('');

    useDebounceEffect(
      () => {
        inputChangeCallback(someVal);
      },
      DELAY,
      [someVal],
    );

    return (
      <div key={divKey} className={formClasses.formDrawerInput}>
        <Autocomplete
          noOptionsText="No locations found"
          fullWidth
          disablePortal
          options={options}
          getOptionLabel={(option: LocationSelectOption) => option?.name || ''}
          onChange={(_e, newVal) => {
            const newOption = newVal as LocationSelectOption;
            if (newOption) {
              updateInputValue(newOption.id, 'locationId');
            }
          }}
          onClose={(e) => {
            if (inputChangeCallback) {
              setSomeVal(undefined);
            }
          }}
          onInputChange={(e, _value) => {
            if (inputChangeCallback) {
              setSomeVal(_value);
            }
          }}
          renderOption={(option: LocationSelectOption) => (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography>{option.name}</Typography>
              <Typography style={{ color: '#9a9a9a', fontSize: 14, fontWeight: 300 }}>
                {option.address}
              </Typography>
            </div>
          )}
          renderInput={(params) => <TextField {...params} label="Location Name" />}
        />
      </div>
    );
  },
);
